function c(n, o) {
  const e = { ...n }, t = Array.isArray(o) ? o : [o];
  for (const r of t)
    delete e[r];
  return e;
}
export {
  c as omit
};
